<sp-editor
    [content]="content"
    [baseHref]="baseHref"
    [inline]="inline"
    [toolbarMenu]="toolbarMenu"
    [containerId]="containerId"
    [placeholder]="placeholder"
    [changeContentOnKeyUp]="changeContentOnKeyUp"
    [selectedThemeColors]="selectedThemeColors()"
    [selectedDeviceMode]="deviceMode"
    (changeContent)="changeHandler($event)"
    (focusOutEvent)="focusOutEvent.emit($event)"
    (focusInEvent)="focusInEvent.emit($event)"
    (isEmptyContent)="isEmptyContent.emit($event)"
>
</sp-editor>
